module.exports = __webpack_public_path__ + "static/media/YDQ.80d023fc.pdf";